import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    headerLabel1: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please provide a guest count' },
      ]
    },
    sitename: {
      validations: [
        { type: 'required', message: 'Please provide a venue' },
    ]
    },
    reference: {
      validations: [
        { type: 'required', message: 'Please select an option' },
      ]
    },
    notes: {
      validations: [
        { type: 'required', message: 'Please provide additional information' },
      ]
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please provide an event date' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    }
  },
  layout: {
    rows: [
      {
        fields: [
            {
            type: 'label',
            size: 'Medium',
            label: 'SEND US A MESSAGE',
            mapping: 'headerLabel',
            customClasses: ['header']
        }
    ]
    },
    {
      fields: [
          {
          type: 'label',
          size: 'Medium',
          label: 'LET\'S SCHEDULE A SITE VISIT! FILL OUT THE FORM OR CALL US AT 916-808-0957',
          mapping: 'headerLabel1',
          customClasses: ['header1']
        }
      ]
      },
            {
    fields: [
        {
        type: 'text',
        size: 'Medium',
        label: 'First Name:*',
        mapping: 'firstName'
},
{
        type: 'text',
        size: 'Medium',
        label: 'Last Name:*',
        mapping: 'lastName'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Phone:*',
            mapping: 'telNumber'
          },
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Preferred Date:*',
            mapping: 'eventDate'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Number of Guests:*',
            mapping: 'plannedguestcount'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Venue:*',
            options:[
              {label: 'Pavilion at Haggin Oaks', value: 'Pavilion at Haggin Oaks'},
              {label: 'Creekside at Haggin Oaks', value: 'Creekside at Haggin Oaks'},
              {label: 'The Hangout', value: 'The Hangout'},
            ],
            mapping: 'sitename'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How Did You Hear About Us?:*',
            options:[
              {label: 'Facebook', value: 'Facebook'},
              {label: 'Instagram', value: 'Instagram'},
              {label: 'Website', value: 'Website'},
              {label: 'Referral', value: 'Referral'},
              {label: 'Event Guest', value: 'Event Guest'},
              {label: 'Ad', value: 'Ad'},
            ],
            mapping: 'reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Message/Comments:*',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Morton Golf Contact Form',
    formId: '755',
    clientKey: '86C835ED-9C8C-4B9E-82E0-B0EE5820803B',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
